import { getTournamentStats } from '@/api/tournament/tournamentApi';
import { formatCurrency } from '@/components/home/format';
import { MetricCard } from '@/components/home/MetricCard';
import type { TournamentSummary } from '@/types/tournament.model';
import { handleGlobalError } from '@/utils/error-handler';
import { CalendarRange, DollarSign } from 'lucide-react';
import type React from 'react';
import { useCallback, useEffect, useState } from 'react';

export const TournamentsSummarySection: React.FC = () => {
  const [stats, setStats] = useState<TournamentSummary | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchStats = useCallback(async () => {
    try {
      setLoading(true);
      setStats(await getTournamentStats());
    } catch (error) {
      handleGlobalError(
        error,
        'Error',
        'No se pudieron cargar tus estadísticas de torneos. Por favor, intentá nuevamente más tarde.',
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <section className="flex flex-col gap-3">
      <h2 className="text-[16px] font-bold text-gc-ink">Torneos</h2>
      {loading ? (
        <div className="grid grid-cols-2 gap-3">
          {[0, 1].map((i) => (
            <div
              key={i}
              className="h-28 animate-pulse rounded-[14px] border border-gc-line bg-gray-100"
            />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-3">
          <MetricCard
            icon={CalendarRange}
            label="Torneos activos"
            value={String(stats?.tournamentCount ?? 0)}
          />
          <MetricCard
            icon={DollarSign}
            label="Ingresos del año"
            value={formatCurrency(stats?.annualRevenue ?? 0)}
          />
        </div>
      )}
    </section>
  );
};
